export default __webpack_public_path__ + "static/media/shap-01.b33dfa18.svg";